// extracted by mini-css-extract-plugin
export default {"loader":"MGLoader_loader__7DfgF","spinner":"MGLoader_spinner__u-Wpp","mg-loader-spin":"MGLoader_mg-loader-spin__1ZV8L"};